/*
 * @Description: 
 * @Author: 
 * @Date: 2022-01-11 10:48:34
 * @LastEditTime: 2022-10-10 11:42:41
 * @LastEditors: dongqianqian
 * @Usage: 
 */
import Axios from '@/plugins/axios'
// 根据项目id获取项目扩展信息详情
export function getProjectExtend(projectid) {
  return Axios({
    url: `/project-manage/project-extend/${projectid}`,
    method: 'get',
  })
}
// 保存项目扩展信息
export function saveProjectExtend(data) {
  return Axios({
    url: `/project-manage/save-project-extend`,
    method: 'post',
    data: data
  })
}